module.exports = __webpack_public_path__ + "static/img/23-comms.a4296d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-comms.png
// module id = /vas
// module chunks = 1